import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import styles from './TopSearch.module.css'
import { useCallback, useState } from 'react'
import { useGlobalKey } from 'shared-components/hooks/use-global-key'
import { useSearch } from 'shared-components/hooks/use-search'
import InstantSearchResult from 'shared-components/layout/InstantSearchResult'
import { ResponsiveContext } from 'shared-components/contexts/ResponsiveContext'
import { useSearchLinkBuilder } from 'shared-components/hooks/use-search-link-builder'
import { CTopSearchControlProps } from 'shared-definitions/types.component'
import { SearchContext } from '../contexts/SearchContext'

interface TopSearchProps extends BasicStyledComponent {
  control: React.ComponentType<CTopSearchControlProps>
  resultsClassName?: string
  onNavigate?: () => void
}

const TopSearch: React.VFC<TopSearchProps> = ({
  className,
  onNavigate,
  resultsClassName,
  control: Control,
}) => {
  const [focused, setFocused] = useState(false)
  const { search: searchHandler, productsSuggestions } = SearchContext.useContainer()

  const { ready, xl } = ResponsiveContext.useContainer()
  const { value, setValue, results, pending, clearResults, currentQuery } = useSearch(
    async query => {
      const perPage = ready && xl ? 9 : 12

      const [{ data }, { data: dataSuggestions }] = await Promise.all([
        searchHandler(query, 1, perPage),
        productsSuggestions(query, 1, 6),
      ])
      return {
        searchResult: data.posts,
        dataSuggestions: dataSuggestions.items,
      }
    }
  )

  const closeCallback = useCallback(() => {
    setFocused(false)
    clearResults()
  }, [clearResults])

  useGlobalKey({ code: 'Escape' }, closeCallback)

  const resultsLinkBuilder = useSearchLinkBuilder()
  const props = {
    focused,
    currentQuery,
    value,
    pending,
    setValue,
    setFocused,
    closeCallback,
  }

  return (
    <>
      <Control {...props} className={className} />
      <InstantSearchResult
        className={clsx(styles.results, resultsClassName, {
          [styles.resultsHidden]:
            !results || !results.searchResult?.items.length || pending || !focused,
        })}
        resultsLink={resultsLinkBuilder(currentQuery)}
        productsSuggestions={results?.dataSuggestions ?? null}
        posts={results?.searchResult ?? null}
        onNavigate={() => {
          onNavigate?.()
          closeCallback()
        }}
        query={currentQuery}
      />
    </>
  )
}

export default TopSearch
